import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import TasksExecsListByAuthUser from '../../../../../components/Tasks/TasksExecsLists/TasksExecsListByAuthUser';

class NotDoneTasksList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reducerName: `notDoneTasksList`,
      queryParamsStatic: {
        status: 5
      }
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <TasksExecsListByAuthUser
        reducerName={this.state.reducerName}
        queryParamsStatic={this.state.queryParamsStatic}
      />
    );
  }
}

export default withRouter(NotDoneTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/NotDoneTasksList/NotDoneTasksList.js